import { render } from "./AuthenticateUser.vue?vue&type=template&id=70e2164c"
import script from "./AuthenticateUser.vue?vue&type=script&lang=js"
export * from "./AuthenticateUser.vue?vue&type=script&lang=js"

import "./AuthenticateUser.vue?vue&type=style&index=0&id=70e2164c&lang=css"

import exportComponent from "../../../../thejourney/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__